import * as types from './mutation-types'


export const loadTransferredProject = ({ commit }, params) => {
    return new Promise((resolve, reject) => {
        window.axios.get('get/projects/transferred', {params}).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}
export const getUserProjects = ({ commit }, params) => {
    return new Promise((resolve, reject) => {
        window.axios.get('get/user/projects', {params}).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}
export const transferProjectToUser = ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.post('transfer/project/to/user', data).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}
export const restoreTransferredProject = ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
        window.axios.post('restore/transferred/project', payload).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

